import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, Theme, Typography } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { SectionTitle } from '../../components/SectionTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import data from '../../json/tabelle.json';
import { ADD_COM_IRPEF_PercDataClass, DefaultInputProps } from '../../types/types';
import { regioni } from "../../utils/costanti";
import { API_elaboraIForfetari } from '../../utils/functions';

export default function LiquidazioneIrpef(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeLiquidazioneIrpef";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraIForfetari(props, global, name, value, action, true);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    };

    const handleBlur = (e: any) => {
        //API_elaboraIForfetari(props, global);
    }

    const ADD_COM_IRPEF = data.ADD_COM_IRPEF as ADD_COM_IRPEF_PercDataClass;

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionTitle text="IRPEF - Dati dell'imprenditore/professionista"></SectionTitle>

            <SectionSubTitle text="Redditi diversi da impresa/lav. Autonomo"></SectionSubTitle>
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E98"
                label="Pensione"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E98}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E99"
                label="Lav. dipendente e assimilati"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E99}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
                tooltip="Redditi di lavoro dipendente e assimilati per i quali spetta la detrazione d'imposta per redditi di lavoro dipendente."
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E100"
                label="Assimilati lav. dipendente"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E100}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
                tooltip="Redditi assimilati al reddito di lavoro dipendente per i quali spetta la detrazione d'imposta per redditi di lavoro non dipendente."
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E101"
                label="Diversi lettere i) e l)"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E101}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E102"
                label="Fabbricati locati"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E102}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
                tooltip="Redditi dei fabbricati locati diversi da quelli da assoggettare a cedolare secca."
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E103"
                label="Altri"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E103}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
                tooltip="Redditi di capitale, redditi diversi escluse lettere i) e l) e redditi dei terreni affittati o esenti da IMU."
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E104"
                label="Abitazione principale"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E104}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <NumberField
                name="redditiDiversiDaImpresa_LavAutonomo_E105"
                label="Redditi a cedolare secca"
                value={state.liquidazioneIrpef.redditiDiversiDaImpresa_LavAutonomo_E105}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />

            <SectionSubTitle text="Altri dati personali"></SectionSubTitle>
            <Typography variant="h6">Familiari a Carico</Typography>
            <Grid container spacing={1}>
                <Grid container>
                <Grid item lg={3}> 
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.liquidazioneIrpef.altriDatiPersonali_H99}
                                name='altriDatiPersonali_H99'
                                id='altriDatiPersonali_H99'
                                value={state.liquidazioneIrpef.altriDatiPersonali_H99}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Coniuge"
                    />
                </Grid>            
                <Grid item lg={3}> 
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="altriDatiPersonali_I99">Figli n.</InputLabel>
                        <Select
                            className={gClasses.selectIForf}
                            value={state.liquidazioneIrpef.altriDatiPersonali_J99}
                            inputProps={{ name: 'altriDatiPersonali_J99', id: 'altriDatiPersonali_J99' }}
                            onChange={handleChangeSelect}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>            
                <Grid item lg={3}> 
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="altriDatiPersonali_K99">%</InputLabel>
                        <Select
                            className={gClasses.selectIForf}
                            value={state.liquidazioneIrpef.altriDatiPersonali_L99}
                            inputProps={{ name: 'altriDatiPersonali_L99', id: 'altriDatiPersonali_L99' }}
                            onChange={handleChangeSelect}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={50}>50%</MenuItem>
                            <MenuItem value={100}>100%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>            
                </Grid>                
                <Grid container>
                <Grid item lg={3}> 
                    <NumberField
                        name="altriDatiPersonali_L101"
                        label="Oneri deducibili"
                        value={state.liquidazioneIrpef.altriDatiPersonali_L101}
                        className={gClasses.textField}
                        onChange={handleChange} onBlur={handleBlur}
                        helperText="(diversi dai contributi)"
                    />
                </Grid>
                <Grid item lg={3}> 
                    <NumberField
                        name="altriDatiPersonali_L102"
                        label="Detrazioni per oneri"
                        value={state.liquidazioneIrpef.altriDatiPersonali_L102}
                        className={gClasses.textField}
                        onChange={handleChange} onBlur={handleBlur}
                        helperText="ed altre detrazioni e crediti"
                    />
                </Grid>
                </Grid>
                <Grid container >
                <Grid item lg={3}>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="altriDatiPersonali_G104">Regione di residenza</InputLabel>
                        <Select
                            className={gClasses.selectIForf}
                            value={state.liquidazioneIrpef.altriDatiPersonali_I104}
                            inputProps={{ name: 'altriDatiPersonali_I104', id: 'altriDatiPersonali_I104' }}
                            onChange={handleChangeSelect}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            {regioni.map(regione => (
                                <MenuItem key={regione.codice} value={regione.codice}>{regione.descrizione}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item lg={3}>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="altriDatiPersonali_K104">Add. Com. Irpef</InputLabel>
                        <Select
                            className={gClasses.selectIForf}
                            value={state.liquidazioneIrpef.altriDatiPersonali_M104}
                            inputProps={{ name: 'altriDatiPersonali_M104', id: 'altriDatiPersonali_M104' }}
                            onChange={handleChangeSelect}
                        >
                            <MenuItem value={ADD_COM_IRPEF.perc_1}>{ADD_COM_IRPEF.perc_1}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_2}>{ADD_COM_IRPEF.perc_2}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_3}>{ADD_COM_IRPEF.perc_3}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_4}>{ADD_COM_IRPEF.perc_4}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_5}>{ADD_COM_IRPEF.perc_5}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_6}>{ADD_COM_IRPEF.perc_6}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_7}>{ADD_COM_IRPEF.perc_7}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_8}>{ADD_COM_IRPEF.perc_8}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_9}>{ADD_COM_IRPEF.perc_9}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_10}>{ADD_COM_IRPEF.perc_10}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_11}>{ADD_COM_IRPEF.perc_11}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_12}>{ADD_COM_IRPEF.perc_12}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_13}>{ADD_COM_IRPEF.perc_13}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_14}>{ADD_COM_IRPEF.perc_14}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_15}>{ADD_COM_IRPEF.perc_15}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_16}>{ADD_COM_IRPEF.perc_16}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_17}>{ADD_COM_IRPEF.perc_17}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_18}>{ADD_COM_IRPEF.perc_18}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_19}>{ADD_COM_IRPEF.perc_19}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_20}>{ADD_COM_IRPEF.perc_20}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_21}>{ADD_COM_IRPEF.perc_21}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_22}>{ADD_COM_IRPEF.perc_22}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_23}>{ADD_COM_IRPEF.perc_23}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_24}>{ADD_COM_IRPEF.perc_24}%</MenuItem>
                            <MenuItem value={ADD_COM_IRPEF.perc_25}>{ADD_COM_IRPEF.perc_25}%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
               </Grid>
            </Grid>
        </Paper>
    );
}